/** Default page after repo login (admin + agent). */
export const DEFAULT_LANDING_PATH = "/home";

const PERMISSION_LANDING_PATHS = [
  ["home.view", "/home"],
  ["profile.view", "/profile"],
  ["id_card.view", "/id-card"],
  ["cases.view", "/cases"],
  ["find_vehicles.view", "/find-vehicles"],
  ["confirmation.view", "/confirmation"],
  ["feedback.view", "/feedback"],
  ["blacklist.view", "/blacklist"],
  ["upload_records.view", "/bank-details"],
  ["bank_records.view", "/bank-records"],
  ["code_bank_nbfc.view", "/code-bank-nbfc"],
  ["otps.view", "/otps"],
  ["clean_file.view", "/clean-file"],
  ["field_map.view", "/field-map"],
  ["live_tracking.view", "/live-tracking"],
  ["users.view", "/users"],
  ["roles_permissions.manage", "/roles-permissions"],
  ["email_config.manage", "/email-configuration"],
  ["reports.view", "/reports"],
];

export function landingPathForRole(role, permissions = []) {
  if (role === "SSDI_SUPER_ADMIN") return "/ssdi/dashboard";
  if (role === "BANK_ADMIN" || role === "BANK_PERSON") return "/bank/dashboard";
  if (role !== "REPO_ADMIN") {
    const allowedPath = PERMISSION_LANDING_PATHS.find(([key]) => permissions.includes(key));
    if (allowedPath) return allowedPath[1];
  }
  return DEFAULT_LANDING_PATH;
}

/** Encode parent path for ?from= so back links return to the page that opened this screen. */
export function withReturnPath(path, returnTo) {
  const parent = returnTo || DEFAULT_LANDING_PATH;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}from=${encodeURIComponent(parent)}`;
}

export function getReturnPath(searchParams, locationState, fallback = DEFAULT_LANDING_PATH) {
  const fromQuery = searchParams.get("from");
  if (fromQuery) {
    try {
      return decodeURIComponent(fromQuery);
    } catch {
      return fromQuery;
    }
  }
  if (locationState?.from) return locationState.from;
  return fallback;
}

const RETURN_LABELS = {
  "/home": "Home",
  "/bank-details": "Agency Upload Repo List Details",
  "/control-panel": "Control Panel",
  "/find-vehicles": "Find Vehicles",
  "/bank-records": "Banks / NBFCs Repo List Details",
  "/reports": "Reports",
  "/seized-vehicles": "Seized vehicles",
  "/repo-agents-bills": "Repo Agents Bills",
  "/repo-payment": "Repo Payment",
};

export function getReturnLabel(returnPath) {
  if (!returnPath) return "Home";
  const base = returnPath.split("?")[0];
  if (RETURN_LABELS[base]) return RETURN_LABELS[base];
  if (base.startsWith("/seized-vehicles")) return "Seized vehicles";
  if (base.startsWith("/confirmation/vehicle")) return "Vehicle requests";
  if (base.startsWith("/confirmation")) return "Pending confirmations";
  return "previous page";
}
